import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ReceiptsList, useReceipts } from "@/components/ReceiptsList";
import { Receipt } from "@phosphor-icons/react";

const fmt = (n) => (Number(n) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default function Receipts() {
  const [contractor, setContractor] = useState("__all");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const utc = (d, endOfDay) => new Date(`${d}T${endOfDay ? "23:59:59.999" : "00:00:00"}`).toISOString();
  const params = { ...(contractor !== "__all" ? { contractor } : {}), ...(start ? { start: utc(start) } : {}), ...(end ? { end: utc(end, true) } : {}) };
  const [data, load] = useReceipts(params);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight flex items-center gap-3" style={{ fontFamily: "Manrope" }}>
          <Receipt size={32} weight="duotone" className="text-blue-600" /> Recibos
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Todos os recibos de prestação de serviço emitidos — baixe ou reenvie quando precisar</p>
      </div>
      <Card>
        <CardContent className="pt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div><Label>Contratante</Label>
            <Select value={contractor} onValueChange={setContractor}>
              <SelectTrigger data-testid="receipts-filter-contractor"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__all">Todas</SelectItem>
                {data.contractors.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div><Label>De</Label><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="receipts-filter-start" /></div>
          <div><Label>Até</Label><Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="receipts-filter-end" /></div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="text-lg">{data.items.length} recibo(s)</CardTitle>
          <span className="font-bold text-emerald-700" data-testid="receipts-total">{fmt(data.total)}</span>
        </CardHeader>
        <CardContent><ReceiptsList items={data.items} onChanged={load} showTrip /></CardContent>
      </Card>
    </div>
  );
}
